//stay safe section 

(function($) {
    $.fn.swipeDetector = function(options) {
        // States: 0 - no swipe, 1 - swipe started, 2 - swipe released
        var swipeState = 0;
        // Coordinates when swipe started
        var startX = 0;
        var startY = 0;
        // Distance of swipe
        var pixelOffsetX = 0;
        var pixelOffsetY = 0;
        // Target element which should detect swipes.
        var swipeTarget = this;
        var defaultSettings = {
        // Amount of pixels, when swipe don't count.
        swipeThreshold: 70,
        // Flag that indicates that plugin should react only on touch events.
        // Not on mouse events too.
        useOnlyTouch: false
        };

        // Initializer
        (function init() {
        options = $.extend(defaultSettings, options);
        // Support touch and mouse as well.
        swipeTarget.on("mousedown touchstart", swipeStart);
        $("html").on("mouseup touchend", swipeEnd);
        $("html").on("mousemove touchmove", swiping);
        })();

        function swipeStart(event) {
        if (options.useOnlyTouch && !event.originalEvent.touches) return;

        if (event.originalEvent.touches) event = event.originalEvent.touches[0];

        if (swipeState === 0) {
            swipeState = 1;
            startX = event.clientX;
            startY = event.clientY;
        }
        }

        function swipeEnd(event) {
        if (swipeState === 2) {
            swipeState = 0;
            if (
            Math.abs(pixelOffsetX) > Math.abs(pixelOffsetY) &&
            Math.abs(pixelOffsetX) > options.swipeThreshold
            ) {
            // Horizontal Swipe
            if (pixelOffsetX < 0) {
                swipeTarget.trigger($.Event("swipeLeft.sd"));
            } else {
                swipeTarget.trigger($.Event("swipeRight.sd"));
            }
            } 
        }
        }

        function swiping(event) {
        // If swipe don't occuring, do nothing.
        if (swipeState !== 1) return;

        if (event.originalEvent.touches) {
            event = event.originalEvent.touches[0];
        }

        var swipeOffsetX = event.clientX - startX;
        var swipeOffsetY = event.clientY - startY;

        if (
            Math.abs(swipeOffsetX) > options.swipeThreshold ||
            Math.abs(swipeOffsetY) > options.swipeThreshold
        ) {
            swipeState = 2;
            pixelOffsetX = swipeOffsetX;
            pixelOffsetY = swipeOffsetY;
        }
        }

        return swipeTarget; // Return element available for chaining.
    };
    })(jQuery);

$(document).ready(function(){


    $('.owl-carousel .content>.owl-dots .owl-dot').first().addClass('active');

    $('.owl-carousel .item .images-carousel').owlCarousel({
        loop:true,
        margin:200,
        items: 1
    })

    $('.owl-carousel .item>.content:not(.carousel-mobile) .texts').owlCarousel({
        loop:true,
        margin:20,
        items: 1
    })

    $('.carousel-mobile').owlCarousel({
        loop:true,
        margin:20,
        items: 1
    })

    $(document).on('touchmove mousemove','.owl-carousel .item >  .images .owl-item', function(e){
        data_index = $('.owl-carousel .item >  .images .owl-item.active .image').attr('data-index')
        $('.owl-carousel .item >  .images .owl-item.active').attr('data-index');
        $('.owl-carousel .owl-dots.desktop .owl-dot[data-index="'+data_index+'"]').addClass('active').siblings().removeClass('active');
     
        $('.item >.content > .texts .owl-dots .owl-dot:nth-child('+data_index+') span').click();

    })

    $(document).on('touchmove mousemove','.owl-carousel .item > .content > .texts .owl-item', function(e){
       
        data_index = $('.owl-carousel .item >  .content > .texts .owl-item.active .text').attr('data-index')

        $('.item > .images .owl-dots .owl-dot:nth-child('+data_index+') span').click();
        $('.owl-carousel .owl-dots.desktop .owl-dot[data-index="'+data_index+'"]').addClass('active').siblings().removeClass('active');
    })



   
    $('.owl-carousel .content>.owl-dots.desktop .owl-dot').click(function(e){
        data_index = $(e.target).attr('data-index');

        $('.owl-carousel .owl-dots.desktop .owl-dot[data-index="'+data_index+'"]').addClass('active').siblings().removeClass('active');
        $('.owl-carousel .content .text[data-index="'+data_index+'"]').addClass('active').siblings().removeClass('active');
        $('.owl-carousel .item .image[data-index="'+data_index+'"]').addClass('active').siblings().removeClass('active');
    })

    $('.content>.owl-dots.desktop .owl-dot').click(function(e){
        data_index = $(e.target).attr('data-index')
        $('.content .texts .owl-dots .owl-dot:nth-child('+data_index+') span').click();  
        $('.owl-carousel .images .owl-dots .owl-dot:nth-child('+data_index+') span').click();
    })

    $('.owl-carousel .prev').click(function(){
        if($('.owl-carousel .content>.owl-dots.desktop .owl-dot.active').prev().length){      
            $('.owl-carousel .content>.owl-dots.desktop .owl-dot.active').prev().click();
        }else{
            $('.owl-carousel .content>.owl-dots.desktop .owl-dot').last().click();
        }   
    })

    $('.owl-carousel .next').click(function(){

       if($('.owl-carousel .content>.owl-dots .owl-dot.active').next().length){
            $('.owl-carousel .content>.owl-dots .owl-dot.active').next().click();
        }else{
            $('.owl-carousel .content>.owl-dots .owl-dot').first().click();
        }

    })  
})



$(document).ready(function(){
    setTimeout(function(){
        $('html').css('padding-bottom', '0px')
    },2000)


    setTimeout(function(){
        $('.dots .dot').last().addClass('active');
        $('.slider .description .text').last().addClass('active');
        // $('.slider .images .image').first().addClass('active');
    },500)


    $('.dots .dot').click(function(e){
        data_index = $(e.target).attr('data-index');
        // $('.slider .images .image.active').addClass('down');

        data_index = $(e.target).attr('data-index');
        $('.images .image[data-index="'+data_index+'"]').addClass('active').siblings().removeClass('active');
        $('.dots .dot[data-index="'+data_index+'"]').addClass('active').siblings().removeClass('active');
        $('.description .text[data-index="'+data_index+'"]').addClass('active').siblings().removeClass('active');
        
      
        setTimeout(function(){
            $('.slider .images .image.left[data-index="'+data_index+'"]').removeClass('left');
            $('.slider .images .image.right[data-index="'+data_index+'"]').removeClass('right');
            $('.slider .images .image img').css('transform','translateX(0px) translateY(0px)');
            $('.slider .images .image img').css('transform', '')
        },1300)
    })

    $('.slider .image').each(function(){
        height_div = $('.slider .image').height();
        height_image = $(this).height();
        $(this).find('img').css('top',(height_div - height_image)/2);
    })

    $('.slider .tap-left').click(function(){

        $('.slider .images .image.active').addClass('left');

        if($('.slider .dot.active').prev().length){      
            $('.slider .dot.active').prev().click();
        }else{
            $('.slider .dot').last().click();
        }
    })

    $('.slider .tap-right').click(function(){
        $('.slider .images .image.active').addClass('right');
        if($('.slider .dot.active').next().length){
            $('.slider .dot.active').next().click();
        }else{
            $('.slider .dot').first().click();
        }
    })


        if($('#tips').length){

            $(window).scroll(function(){
                scroll = $(window).scrollTop();
                div_position = $('#tips').position().top
    
                if(scroll > div_position - 800){
                    diferent = (scroll - div_position) / 1.3;
                    diferent = (-diferent) ;
                    $('#tips .row').css('background-position-y', diferent+'px' )
                }
    
            })
        }
  
})

//header section 
$(document).ready(function(){

    scrolling_to_top = 0;

    $('body').on('touchmove', function(e){
        if($(this).scrollTop() == 0 && $(window).scrollTop() == 0){
            scrolling_to_top = scrolling_to_top + 1;
        }

        if(scrolling_to_top > 1){
            $(window).scrollTop();
            setTimeout(function(){
                $('.durex-tinder-page').removeClass('fixed');

                $('.arrow-icon').removeClass('hide_menu');   
            },210)   
            scrolling_to_top = 0;
            $('#tinder__header .tinder__header').css('height','');

            $('#tinder__header .tinder__header').css('transition', '');


        }

  

    })

    $('body').on('wheel', function(event){

        if(event.originalEvent.wheelDelta > 0 && $(window).scrollTop() == 0){
            scrolling_to_top = scrolling_to_top + 1;
        }

        if(scrolling_to_top > 2){
            $(window).scrollTop();
            setTimeout(function(){
                $('.durex-tinder-page').removeClass('fixed');

                $('.arrow-icon').removeClass('hide_menu');   
            },210)   
            scrolling_to_top = 0;
            $('#tinder__header .tinder__header').css('height','');

            $('#tinder__header .tinder__header').css('transition', '');
        }

    })



    $(window).on('touch')

    $('body').prepend($('#tinder__header').html());
  


        $(window).scroll(function(){
        scroll = $(window).scrollTop();

         var window_height = $(window).height();
         var window_top_position = $(window).scrollTop();
         var window_bottom_position = (window_top_position + window_height);

         var $element = $('#tinder_play');
         var element_height = $element.outerHeight();
         var element_top_position = $element.offset().top;
         var element_bottom_position = (element_top_position + element_height);
     

        if((element_bottom_position >= window_top_position) &&
        (element_top_position <= window_bottom_position)){
            setTimeout(function(){
                $('#tinder_play h2').addClass('fadeUp');
                $('#tinder_play .description').addClass('fadeDown')
            },100)
           
        }else{
            $('#tinder_play h2').removeClass('fadeUp');
            $('#tinder_play .description').removeClass('fadeDown')
        }


        var $element2 = $('#discounts .content .title');
        var element_height2 = $element2.outerHeight();
        var element_top_position2 = $element2.offset().top;
        var element_bottom_position2 = (element_top_position2 + element_height2);
    
        if((element_bottom_position2 >= window_top_position) &&
        (element_top_position2 <= window_bottom_position)){
            $('#discounts .content .top_desciption').addClass('fadeUp');
            $('#discounts .content .title').addClass('fadeUp');
            $('#discounts .content .button').addClass('fadeDown');
            $('#discounts .content .description').addClass('fadeDown');
        }else{
            $('#discounts .content .top_desciption').removeClass('fadeUp');
            $('#discounts .content .title').removeClass('fadeUp');
            $('#discounts .content .button').removeClass('fadeDown');
            $('#discounts .content .description').removeClass('fadeDown');
        }


        var $element3 = $('#dataideas .start');
        var element_height3 = $element3.outerHeight();
        var element_top_position3 = $element3.offset().top;
        var element_bottom_position3 = (element_top_position3 + element_height3);
        if((element_bottom_position3 >= window_top_position) &&
        (element_top_position3 <= window_bottom_position)){
            $('#dataideas .start h2').addClass('fadeUp');
            $('#dataideas .start h3').addClass('fadeUp');
            $('#dataideas .description').addClass('fadeDown');
            $('#dataideas .start .button').addClass('fadeDown');
            $('#dataideas .button').addClass('fadeDown');
        }else{
            $('#dataideas .start h2').removeClass('fadeUp');
            $('#dataideas .start h3').removeClass('fadeUp');
            $('#dataideas .description').removeClass('fadeDown');
            $('#dataideas .start .button').removeClass('fadeDown');
        }



        header_height = $('.durex-tinder-page main .tinder__header').height()
   

        if(scroll <  $('#tinder__header .tinder__header').height() && $('.durex-tinder-page.fixed').length  ){
            $('#tinder__header .tinder__header').css('height', scroll);
            $('#tinder__header .tinder__header').css('transition', 'unset');
        }
 

        if((scroll > (header_height + 5)) && $('.durex-tinder-page.fixed').length == 0 ){

            $('.durex-tinder-page').addClass('fixed');
            $('.arrow-icon').addClass('hide_menu');    
        }

    })




    $('.arrow-icon').click(function(){
        $('.arrow-icon').toggleClass('hide_menu');
        
    })

    $('nav li span, #discounts .button').click(function(e){
     if ($(e.target).attr('data-href').indexOf('#dataideas') > -1){
            $('.durex-tinder-page').addClass('fixed');
            $('#tinder__header .tinder__header').css('height', '0vh')
            $('.arrow-icon').addClass('hide_menu');
                $('html, body').animate({
                    scrollTop: 1
                }, 500);
        }else if($(e.target).attr('data-href').indexOf('#staying_safe') > -1 && $(window).width() < 768 ){
            $('.arrow-icon').addClass('hide_menu');

            setTimeout(function(){
                $('html, body').animate({
                    scrollTop: $($(e.target).attr('data-href')).position().top + $($(e.target).attr('data-href')).height() - $(window).height() - 100
                }, 1000);
                },200)
        }
        else if($('.durex-tinder-page.fixed').length){

            $('.arrow-icon').addClass('hide_menu');
            setTimeout(function(){
                $('html, body').animate({
                    scrollTop: $($(e.target).attr('data-href')).position().top - 68
                }, 1000);
                },200)
            
        }
        
        else{

            $('#tinder__header .tinder__header').css('height', '0vh');
            scroll_to = $($(e.target).attr('data-href')).position().top - $('.durex-tinder-page main .tinder__header').height() - 68;
            $('.durex-tinder-page').addClass('fixed');
            $('.arrow-icon').addClass('hide_menu');
            setTimeout(function(){
                scroll_to = $($(e.target).attr('data-href')).position().top - $('.durex-tinder-page main .tinder__header').height() - 68;
                $('html, body').animate({
                    scrollTop: scroll_to
                }, 1000);
            },300)
        }  
    })
})


//tinder swipe
$(document).ready(function() {

    var animating = false;
    var cardsCounter = 0;
    var numOfCards = 6;
    var decisionVal = 80;
    var pullDeltaX = 0;
    var deg = 0;
    var $card, $cardReject, $cardLike;
  
    function pullChange() {
    animating = true;
    deg = pullDeltaX / 10;
    opacity = Math.abs((1 / pullDeltaX) * 130)

      $card.css("transform", "translateX("+ pullDeltaX +"px) rotate("+ deg +"deg)").css('opacity', opacity);
  
      var opacity = pullDeltaX / 100;
      var rejectOpacity = (opacity >= 0) ? 0 : Math.abs(opacity);
      var likeOpacity = (opacity <= 0) ? 0 : opacity;
    //   $cardReject.css("opacity", rejectOpacity);
    //   $cardLike.css("opacity", likeOpacity);
    };
  
    function release() {
  
      if (pullDeltaX >= decisionVal) {
        $card.addClass("to-right");
      } else if (pullDeltaX <= -decisionVal) {
        $card.addClass("to-left");
      }
      
      if (Math.abs(pullDeltaX) >= decisionVal) {
        $card.addClass("inactive");
  
        setTimeout(function() {
          $card.addClass("below").removeClass("inactive to-left to-right");
          
          cardsCounter++;
          if (cardsCounter === numOfCards) {
            cardsCounter = 0;
            $(".slider .images .image").removeClass("below");
            $(".slider .images .image").last().addClass("below");

          }
        }, 300);
      }
      if (Math.abs(pullDeltaX) < decisionVal) {
        $card.addClass("reset");
      }
  


      setTimeout(function() {
        $card.attr("style", "").removeClass("reset")
          .find(".demo__card__choice").attr("style", "");
  
        pullDeltaX = 0;
        animating = false;
      }, 300);
    };

  
    $(document).on("mousedown touchstart", ".slider .images .image:not(.inactive)", function(e) {
        e.preventDefault();
        if($(window).width() < 800){
            $('body').css('overflow','hidden');
        }
      if (animating) return;
  
      $card = $(this);
    //   $cardReject = $(".demo__card__choice.m--reject", $card);
    //   $cardLike = $(".demo__card__choice.m--like", $card);
      var startX =  e.pageX || e.originalEvent.touches[0].pageX;
  
      $(document).on("mousemove touchmove", function(e) {
        var x = e.pageX || e.originalEvent.touches[0].pageX;
        pullDeltaX = (x - startX);
        if (!pullDeltaX) return;
        pullChange();
      });

      $(document).on("mouseup touchend", function() {

        $(document).off("mousemove touchmove mouseup touchend");

        if (!pullDeltaX) return; // prevents from rapid click events
        release();

        $('body').css('overflow','');

        data_index = $card.attr('data-index') - 1;
        $('.slider .image[data-index="'+$card.attr('data-index')+'"] img').css('transform','')
        if(data_index){
            $('.slider .dots .dot[data-index="'+data_index+'"]').click()
        }else{
            $('.slider .dots .dot').last().click();
        }
        
      });

      
    });
  
  });

  //tinder end





    
//GET FREE CONDOMS PAGE SCRIPTS

!function(e){var n;if("function"==typeof define&&define.amd&&(define(e),n=!0),"object"==typeof exports&&(module.exports=e(),n=!0),!n){var t=window.Cookies,o=window.Cookies=e();o.noConflict=function(){return window.Cookies=t,o}}}(function(){function e(){for(var e=0,n={};e<arguments.length;e++){var t=arguments[e];for(var o in t)n[o]=t[o]}return n}function n(e){return e.replace(/(%[0-9A-Z]{2})+/g,decodeURIComponent)}return function t(o){function r(){}function i(n,t,i){if("undefined"!=typeof document){"number"==typeof(i=e({path:"/"},r.defaults,i)).expires&&(i.expires=new Date(1*new Date+864e5*i.expires)),i.expires=i.expires?i.expires.toUTCString():"";try{var c=JSON.stringify(t);/^[\{\[]/.test(c)&&(t=c)}catch(e){}t=o.write?o.write(t,n):encodeURIComponent(String(t)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),n=encodeURIComponent(String(n)).replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent).replace(/[\(\)]/g,escape);var f="";for(var u in i)i[u]&&(f+="; "+u,!0!==i[u]&&(f+="="+i[u].split(";")[0]));return document.cookie=n+"="+t+f}}function c(e,t){if("undefined"!=typeof document){for(var r={},i=document.cookie?document.cookie.split("; "):[],c=0;c<i.length;c++){var f=i[c].split("="),u=f.slice(1).join("=");t||'"'!==u.charAt(0)||(u=u.slice(1,-1));try{var a=n(f[0]);if(u=(o.read||o)(u,a)||n(u),t)try{u=JSON.parse(u)}catch(e){}if(r[a]=u,e===a)break}catch(e){}}return e?r[e]:r}}return r.set=i,r.get=function(e){return c(e,!1)},r.getJSON=function(e){return c(e,!0)},r.remove=function(n,t){i(n,"",e(t,{expires:-1}))},r.defaults={},r.withConverter=t,r}(function(){})});

function getParameter(theParameter) {
      var params = window.location.search.substr(1).split('&');
      for (var i = 0; i < params.length; i++) {
        var p=params[i].split('=');
         if (p[0] == theParameter) {
          return decodeURIComponent(p[1]);
        }
      }
      return false;
    }
    url_src = getParameter('utm_source');
    url_mdm = getParameter('utm_medium');
    url_cpn = getParameter('utm_campaign');
 
 
 
    // I retrieve data from my cookie (if it exists) and I create an object in JavaScript.
    var pepites = new Object();
    var pate_cookie = Cookies.get('cookie_utms');
    // If at least one URL parameter exist AND the cookie doesn't exist
    if((url_src!== false || url_mdm!==false || url_cpn!==false) && (pate_cookie == null || pate_cookie == "" )) {
      if(url_src!== false){
        pepites["source"] = url_src;
      }
      if(url_mdm!==false){
        pepites["medium"] = url_mdm;
      }
      if (url_cpn!==false) {
        pepites["campaign"] = url_cpn;
      }
      Cookies.set('cookie_utms', pepites, { expires: 120 } );
    }
    // Else if we get at least URL parameter AND the cookie exist
    else if((url_src!== false || url_mdm!==false || url_cpn!==false) && (pate_cookie != null || pate_cookie != "")) {
      pate_cookie_choco = JSON.parse(pate_cookie);
      if(pate_cookie_choco["source"] != undefined) {
        if(url_src!== false && pate_cookie_choco["source"].indexOf(url_src) != -1 ){
          pepites["source"] = pate_cookie_choco["source"];
        }
        else if(url_src!== false){
        pepites["source"] = pate_cookie_choco["source"]+"-"+url_src;
        }
        else if ( url_src == false && pate_cookie_choco["source"] != undefined) {
        pepites["source"] = pate_cookie_choco["source"];
        }
      }                  
      else if ( url_src!== false ) {
          pepites["source"] = url_src;
      }
      if(pate_cookie_choco["medium"] != undefined) {
        if(url_mdm!== false && pate_cookie_choco["medium"].indexOf(url_mdm) != -1 ){
          pepites["medium"] = pate_cookie_choco["medium"];
        }
        else if(url_mdm!== false ) {
        pepites["medium"] = pate_cookie_choco["medium"]+"-"+url_mdm;
        }
        else if(url_mdm == false){
        pepites["medium"] = pate_cookie_choco["medium"];
        }
      }
      else if(url_mdm!== false){
        pepites["medium"] = url_mdm;
      }
      if(pate_cookie_choco["campaign"] != undefined) {
        if(url_cpn!== false && pate_cookie_choco["campaign"].indexOf(url_cpn) != -1 ){
          pepites["campaign"] = pate_cookie_choco["campaign"];
        }
        else if(url_cpn!== false) {
        pepites["campaign"] = pate_cookie_choco["campaign"]+"-"+url_cpn;
        }  
        else if(url_cpn == false){
          pepites["campaign"] = pate_cookie_choco["campaign"];
        }
      }
      else if(url_cpn!== false){
        pepites["campaign"] = url_cpn;
      }
      Cookies.set('cookie_utms', pepites, { expires: 120 } );
    }





    $(document).ready(function(){
        if($('.get-free-product__product').length > 1){
            $('.get-free-product__product').each(function(key,item){
                if(key>1){
                    $(item).css('opacity','0').css('display','none').css('float','right');
                    $('.button.load-more').show();
                }
            })

            $('.get-free-product .load-more').click(function(){
                    $('.get-free-product__product').each(function(){
                        $(this).addClass('active')
                })
                $('.button.load-more').hide();
            })
        }

        $('footer.site-footer .page-width').prepend('<div style="text-align: center;" class="footer-description">* Términos y condiciones promocionales: Código de descuento válido hasta el 31.12.2019 a las 11:59 p.m. GMT. La oferta se aplica a los paquetes preservativos RED de 10 condones y de Fun Mix de 10 condones de <a href="/">durex.es<a/> solo y hasta fin de existencias. Se aplican cargos de envío. El código es válido solo para los suscriptores de correo electrónico de Durex que se registraron a través de Tinder. Limitado a un uso por pedido y por cliente. No es válido junto con ningún otro cupón o código de descuento. La oferta puede ser retirada o variada cuando lo consideremos necesario y razonable hacerlo. Solo mayores de 18 años.</div>')


        cookie = Cookies.get('cookie_utms');
        if(cookie != undefined){
                var cookie_choco = JSON.parse(cookie);
                var cookie_cpn = cookie_choco["campaign"];
                if(!(cookie_cpn.indexOf('inder') > -1)){
                    $('.get-free-product .title-top').html('Lo sentimos, debes ser un usuario de Tinder para beneficiar de esta promoción. Por favor vea nuestros T&Cs *');
                    $('.get-free-product .bottom-description').hide();
                    // $('.footer-description').hide();
                }
        }else{
            $('.get-free-product .title-top').html('Lo sentimos, debes ser un usuario de Tinder para beneficiar de esta promoción. Por favor vea nuestros T&Cs *');
            $('.get-free-product .bottom-description').hide();
            // $('.footer-description').hide();
        }
    })